import { render } from "./SMSTermsOfService.vue?vue&type=template&id=22eacc77"
import script from "./SMSTermsOfService.vue?vue&type=script&lang=js"
export * from "./SMSTermsOfService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__